function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @file Capitan
 * @desc Global Object for Capitan
 * @module Capitan/Capitan
 * @copyright Brandung GmbH & Co KG (http://www.brandung.de/)
 * @author Sebastian Steiner
 * @version 2.0
 * @license MIT License (MIT)
 * @date 21.01.2018
 *
 */
import CapGetComputedStyle from './es6/CapGetComputedStyle';
import CapSmartResize from './es6/CapSmartResize';
import UAParser from 'ua-parser-js';

var Capitan = /*#__PURE__*/function () {
  function Capitan() {
    _classCallCheck(this, Capitan);

    this.Vars = {};
    this.initObject();
    this.setEventClassListener();
    this.initResizer();
    this.resizeHandler();
    this.initBreakpoints();
    this.initDeviceCheck();
    this.initClasses();
    this.initLegacyBrowserCheck();
    this.initBrowserCheck();
  }

  _createClass(Capitan, [{
    key: "initResizer",
    value: function initResizer() {
      CapSmartResize(this.resizeHandler, 100, false, this);
    }
  }, {
    key: "getBreakpoints",
    value: function getBreakpoints() {
      return this.Vars.breakpoints;
    }
  }, {
    key: "assertBreakpoint",
    value: function assertBreakpoint(operator, breakpoint) {
      var breakpoints = Object.keys(this.getBreakpoints()),
          curBreakpointIndex = breakpoints.indexOf(this.getCurrentBreakpoint()),
          conditionalBreakpointIndex = breakpoints.indexOf(breakpoint);

      switch (operator) {
        case 'eq':
          return curBreakpointIndex === conditionalBreakpointIndex;

        case 'lt':
          return curBreakpointIndex < conditionalBreakpointIndex;

        case 'ht':
          return curBreakpointIndex > conditionalBreakpointIndex;

        default:
          return false;
      }
    }
  }, {
    key: "getCurrentBreakpoint",
    value: function getCurrentBreakpoint() {
      var windowWidth = window.innerWidth;
      var breakpoints = Object.keys(this.Vars.breakpoints);
      var breakpoint = '';

      for (var i = breakpoints.length - 1; i >= 0; i -= 1) {
        breakpoint = this.Vars.breakpoints[breakpoints[i]];

        if (windowWidth >= breakpoint) {
          return breakpoints[i];
        }

        if (i === 0 && windowWidth < breakpoint) {
          return breakpoints[i];
        }
      }
    }
  }, {
    key: "getCurrentOrientation",
    value: function getCurrentOrientation() {
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      var htmlNode = this.Vars.html;

      if (windowWidth <= windowHeight) {
        return 'portrait';
      }

      return 'landscape';
    }
  }, {
    key: "CapEventHandling",
    value: function CapEventHandling(el, event, content) {
      var event = document.createEvent('CustomEvent');
      event.initCustomEvent(event, true, true, content);
      el.dispatchEvent(event);
    }
  }, {
    key: "resizeHandler",
    value: function resizeHandler() {
      var currentBreakpoint = this.getCurrentBreakpoint();
      var currentOrientation = this.getCurrentOrientation();
      var breakpoint = "on-breakpoint-".concat(currentBreakpoint);
      var orientation = "on-orientation-".concat(currentOrientation);
      this.Vars.currentBreakpoint = currentBreakpoint;
      this.Vars.currentOrientation = currentOrientation;
      this.Vars.body.className = this.Vars.body.className.replace(/\s?on-breakpoint-(xs|sm|md|lg|xl|xxl|hd|mhd|uhd)/g, '');
      this.Vars.body.classList.add("on-breakpoint-".concat(this.Vars.currentBreakpoint)); //    this.CapEventHandling(this.Vars.doc, 'on-set-class', breakpoint);
      //    this.CapEventHandling(
      //      this.Vars.doc,
      //      'on-changed-breakpoint',
      //      this.Vars.currentBreakpoint
      //    );

      this.Vars.body.className = this.Vars.body.className.replace(/\s?on-orientation-(landscape|portrait)/g, '');
      this.Vars.body.classList.add("on-orientation-".concat(this.Vars.currentOrientation)); //   this.CapEventHandling(this.Vars.doc, 'on-set-class', orientation);
    }
  }, {
    key: "initBreakpoints",
    value: function initBreakpoints() {
      try {
        this.Vars.breakpoints = JSON.parse(CapGetComputedStyle('body', ':before', 'content'));
      } catch (e) {}
    }
  }, {
    key: "initDeviceCheck",
    value: function initDeviceCheck() {
      var parser = new UAParser();
      var result = parser.getResult().device.type;

      if (typeof result != 'undefined') {
        this.Vars.currentDevice = result;
      }
    }
  }, {
    key: "initLegacyBrowserCheck",
    value: function initLegacyBrowserCheck() {
      // const fallbackPage = 'http://192.168.0.101:8080/page-500-error.html#';
      var fallbackPage = '/browserincompatibility#';
      var parser = new UAParser();
      var currentBrowser = [parser.getResult().browser.version.slice(0, 2), parser.getResult().browser.name];
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;

      if (window.localStorage.getItem('LegacyBrowserUse') != 'accepted' && msie) {
        window.location.replace(fallbackPage);
        var acceptLegacyBrowser = document.querySelector('.browserCheckButton');

        if (acceptLegacyBrowser) {
          acceptLegacyBrowser.addEventListener('click', function () {
            window.localStorage.setItem('LegacyBrowserUse', 'accepted');
            window.location.replace(location.origin);
          });
        }
      }
    }
  }, {
    key: "initBrowserCheck",
    value: function initBrowserCheck() {
      var parser = new UAParser();
      var browserCheck = document.querySelector('.browser-check--get-browser');
      var browserDetection = parser.getResult().browser.name + '&nbsp;' + 'Version' + '&nbsp;' + parser.getResult().browser.version.slice(0, 6);
      browserDetection = '&nbsp;' + browserDetection + '&nbsp;';
      var browserDetectionElement = document.querySelector('.browser-check--get-browser');

      if (typeof browserDetection != 'undefined' && browserCheck) {
        browserCheck.innerHTML = browserDetection;
      }
    }
  }, {
    key: "initObject",
    value: function initObject() {
      this.Vars = {
        // path to assets folder
        folderPath: 'Config.paths.liveUrl',
        // standard breakpoints
        breakpoints: {
          xs: 320,
          sm: 480,
          md: 768,
          lg: 991,
          xl: 1280,
          xxl: 1440,
          hd: 1920,
          mhd: 2440,
          uhd: 3840
        },
        // mobile first (xs, sm, md, lg, xl)
        currentBreakpoint: 'xs',
        // portrait first (portrait, landscape)
        currentOrientation: 'portrait',
        currentDevice: '',
        isNativeMobile: window.navigator.userAgent.indexOf('Android') > 0 || // Android
        window.navigator.userAgent.indexOf('iPhone') > 0 || // iPhone
        window.navigator.userAgent.indexOf('iPad') > 0,
        // iPad
        isFF: window.navigator.userAgent.indexOf('Firefox') > -1,
        // Firefox
        isIE: window.navigator.userAgent.indexOf('MSIE ') > 0 || // IE <= 10
        window.navigator.userAgent.indexOf('Trident/') > 0,
        // IE 11
        isEDGE: window.navigator.userAgent.indexOf('Edge/') > 0,
        // IE 12
        isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
        html: document.querySelector('html'),
        body: document.querySelector('body'),
        window: document.window,
        doc: document
      }; // CSS components script namespace

      this.Component = {}; // functions must return something

      this.Function = {}; // everything that has to do with event handling

      this.Handle = {}; // Should be used for scripts that have nothing to do with components, e.g. placeholder polyfills, plugins, etc.

      this.Util = {};
    }
  }, {
    key: "setEventClassListener",
    value: function setEventClassListener() {
      var _this = this;

      this.Vars.doc.addEventListener('on-set-class', function (event, className) {
        _this.Vars.body.classList.add(event.detail);
      });
    }
  }, {
    key: "initClasses",
    value: function initClasses() {
      this.Vars.body.classList.add("on-breakpoint-".concat(this.Vars.currentBreakpoint));
      this.Vars.body.classList.add("on-orientation-".concat(this.Vars.currentOrientation));

      if (this.Vars.isIE) {
        this.Vars.body.classList.add("is-IE");
      }

      if (this.Vars.isFF) {
        this.Vars.body.classList.add("is-FF");
      }

      if (this.Vars.isIOS) {
        this.Vars.body.classList.add("is-IOS");
      }

      if (this.Vars.currentDevice != '') {
        this.Vars.body.classList.add("on-device-".concat(this.Vars.currentDevice));
      }
    }
  }]);

  return Capitan;
}();

export default new Capitan();